import { TeslaFleetAuthenticationScope } from '@/types/teslaFleetAuthentication'

export function getScopesFromAuthorizationUrl(
  authorizationUrl: string | null,
): string[] {
  if (!authorizationUrl) {
    return []
  }
  try {
    const url = new URL(authorizationUrl)
    const scopeParam = url.searchParams.get('scope')
    if (!scopeParam) {
      return []
    }
    return scopeParam
      .split(/[\s+]+/)
      .map((s) => s.trim())
      .filter(Boolean)
  } catch {
    return []
  }
}

export type PermissionType =
  | 'Profile Information'
  | 'Vehicle Information'
  | 'Vehicle Location'
  | 'Vehicle Commands'
  | 'Vehicle Charging Management'
  | 'Energy Product Information'
  | 'Energy Product Settings'

export const permissionToScope: Record<
  PermissionType,
  TeslaFleetAuthenticationScope
> = {
  'Profile Information': 'user_data',
  'Vehicle Information': 'vehicle_device_data',
  'Vehicle Location': 'vehicle_location',
  'Vehicle Commands': 'vehicle_cmds',
  'Vehicle Charging Management': 'vehicle_charging_cmds',
  'Energy Product Information': 'energy_device_data',
  'Energy Product Settings': 'energy_cmds',
}

export const getConfigStatus = (
  missingScopes: TeslaFleetAuthenticationScope[],
): Record<PermissionType, boolean> => ({
  'Profile Information': !missingScopes.includes('user_data'),
  'Vehicle Information': !missingScopes.includes('vehicle_device_data'),
  'Vehicle Location': !missingScopes.includes('vehicle_location'),
  'Vehicle Commands': !missingScopes.includes('vehicle_cmds'),
  'Vehicle Charging Management': !missingScopes.includes(
    'vehicle_charging_cmds',
  ),
  'Energy Product Information': !missingScopes.includes('energy_device_data'),
  'Energy Product Settings': !missingScopes.includes('energy_cmds'),
})

export const idealPermissions: Array<PermissionType> = [
  'Profile Information',
  'Vehicle Information',
  'Vehicle Location',
  'Vehicle Commands',
  'Vehicle Charging Management',
  'Energy Product Information',
  'Energy Product Settings',
] as const

export const requiredPermissions: Array<PermissionType> = [
  'Vehicle Information',
  'Vehicle Charging Management',
]

export const suggestedPermissions: Array<PermissionType> = []
